export const certificateCodes = ['a', 'aa', 'aaa', 'csa_a', 'csa_aa', 'csa_aaa', 'rsf', 'top', 'spc', 'platinum', 'gol']

export const LOCALE_PREFIX = 'scenes.Gnosus.scenes.Report.components.Workspace.components.Blocks.BisnodeCertificates'

export const PLATINUM_CODES = ['rsf', 'top', 'platinum']

export const GOLD_CODES = ['gol']

export const URLS = {
    PLATINUM_CZ: 'https://www.dnb.com/cs-cz/produkty/oceneni-aaa-platinum',
    PLATINUM_SK: 'https://www.dnb.com/sk-sk/produkty/ocenenie-aaa-platinum/',
    GOLD_CZ: 'https://www.dnb.com/cs-cz/produkty/oceneni-aaa-gold',
    GOLD_SK: 'https://www.dnb.com/sk-sk/produkty/ocenenie-aaa-gold',
    FOOTER_CZ: 'https://www.dnb.com/cs-cz/produkty/oceneni-aaa',
    FOOTER_SK: 'https://www.dnb.com/sk-sk/produkty/ocenenie-aaa',
}
